import { Form, Modal } from 'react-bootstrap'
import { useIntl } from 'react-intl'
import { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { InfoCard2 } from '../../widgets/components/UI/InfoCard2'
import { ToolTipUIForModal } from '../../widgets/components/UI/ToolTipUIForModal'
import deleteIcon from '../../../../media/stakeholders/ic-delete.svg'
import { Formik } from 'formik'
import AIGeneratedBrModal from './ai-generated-br-modal'
import { useAuth } from '../../auth'
import { getFileType, toTitleCase } from '../core/_util'
import * as Yup from 'yup'
import { FileUpload } from '../../widgets/components/FileUpload'
import {
  aiGenerateTranscript,
  createMeetingSummary,
  downloadDocument,
  getAgenda,
  getMeetingSummary,
  updateAgenda,
  updateMeetingSummary,
} from '../core/_requests'
import { toast } from 'react-toastify'
import { Quill } from '../../widgets/components/Input/Quill'
import { useDateFormat } from '../../../hooks/useDateFormat'
import { DeleteFileConfirmationModal } from './CancelConfimrationModal'
import { allowedFileTypes } from '../../../core/_constants'
import { useTimeZone } from '../../../hooks/useTimeZone'
import { GTMEvent } from '../../../hooks/gtmHelpers'
import TagManager from 'react-gtm-module'
import TextInput from '../../widgets/components/Input/TextInput'
import brandingConfig from '../../../../config/brandingConfig'

export default function AddDocumentModal({ isActive, setIsActive, meeting }: any) {
  const { formatMessage } = useIntl()
  const [isActiveModal, setIsActiveModal] = useState(false)
  const { isShowHelpBanners, companyId, currentUser } = useAuth()
  const location = useLocation()
  const navigate = useNavigate() // Get the navigate function
  const [modelStatus, setModelStatus] = useState<boolean>(false)
  const [modelVideoStatus, setModelVideoStatus] = useState<boolean>(false)
  const [modelVideoStatus1, setModelVideoStatus1] = useState<boolean>(false)
  const [isEdit, setIsEdit] = useState(false)
  const [aiGeneratedData, setAiGeneratedData] = useState('')
  const [fileTab1, setFileTab1] = useState<any[]>([])
  const [fileTab2, setFileTab2] = useState<any[]>([])
  const [fileTab3, setFileTab3] = useState<any[]>([])
  const [fileTab4, setFileTab4] = useState<any[]>([])
  const [fileTab5, setFileTab5] = useState<any[]>([])
  const [rbNotes, setRbNotes] = useState('')
  const [momNotes, setMomNotes] = useState('')
  const [transNotes, setTransNotes] = useState('')
  const handleClose = () => {
    setModelStatus(false)
  }
  const handleOpen = () => {
    setModelStatus(true)
  }

  const handleVideoClose = () => {
    setModelVideoStatus(false)
  }
  const handleVideoOpen = () => {
    setModelVideoStatus(true)
  }
  const handleVideoClose1 = () => {
    setModelVideoStatus1(false)
  }
  const handleVideoOpen1 = () => {
    setModelVideoStatus1(true)
  }
  const [editData, setEditData] = useState<any>()
  const [loading1, setLoading1] = useState(false)
  const [tab, setTab] = useState(1)
  const [, setIsDisabled] = useState(false)
  const [summaryData, setSummaryData] = useState<any>([])
  const [loading, setLoading] = useState(false)
  const [quillText1, setQuillText1] = useState('')
  const [quillText2, setQuillText2] = useState('')
  const [quillText3, setQuillText3] = useState('')
  const [isChecked1, setIsChecked1] = useState(false)
  const [isChecked2, setIsChecked2] = useState(false)
  const [plainText, setPlainText] = useState('')
  const { getDateValue } = useDateFormat()
  const { getTimeZoneValue } = useTimeZone()
  const [radio, setRadio] = useState(false)
  const [rbTitle, setRbTitle] = useState('')
  const [agendaData, setAgendaData] = useState<any>([])
  const handleTabChange = (index: number) => {
    setIsDisabled(false)
    setIsEdit(false)
    setTab(index + 1)
    if (index + 1 === 5) getAgendaDetails()
    if (files.length > 0) {
      if (tab === 1) setFileTab1(files)
      else if (tab === 2) setFileTab2(files)
      else if (tab === 3) setFileTab3(files)
      else if (tab === 4) setFileTab4(files)
      else setFileTab5(files)
    }
    if (tab === 2) {
      setRbNotes(quillText1 || '')
      setRbTitle(rbTitle)
    }
    if (tab === 3) setMomNotes(quillText2 || '')
    if (tab === 4) setTransNotes(quillText3 || '')
    //setAiGeneratedData(index + 1 === 2 && rbNotes.length > 0 ? rbNotes : index + 1 === 3 && momNotes.length > 0 ? momNotes : index + 1 === 4 && transNotes.length > 0 ? transNotes : '')
    setFiles(
      index + 1 === 1 && fileTab1.length > 0
        ? fileTab1
        : index + 1 === 2 && fileTab2.length > 0
          ? fileTab2
          : index + 1 === 3 && fileTab3.length > 0
            ? fileTab3
            : index + 1 === 4 && fileTab4.length > 0
              ? fileTab4
              : index + 1 === 5 && fileTab5.length > 0
                ? fileTab5
                : []
    )
    getData(index)
    navigate(
      `${location.pathname}?tab=${options[index].slug.toLowerCase()}${meeting ? `&meetingId=${meeting?.meetingId}` : ''
      }`
    )
  }
  const [showCancelModal, setShowCancelModal] = useState(false)
  const [cancelLoading, setCancelLoading] = useState(false)
  const [id, setId] = useState<any>()
  const userSchema = Yup.object().shape({
    ResolutionTitle: Yup.string(),
    BoardResolutionNote: Yup.string(),
    MinutesofMeeting: Yup.string(),
    MeetingTranscript: Yup.string(),
  })

  const initialValues = {
    ResolutionTitle: editData?.resolutionTitle || '',
    BoardResolutionNote: editData?.resolutionNote || '',
    MinutesofMeeting: editData?.minutesOfMeetingNotes || '',
    MeetingTranscript: editData?.transcriptNotes || '',
  }
  const options = [
    {
      id: 1,
      title: formatMessage({ id: 'Recording' }),
      subTitle: formatMessage({ id: 'Add recording files of the meeting' }),
      slug: 'Recording',
    },
    {
      id: 2,
      title: formatMessage({ id: 'Board Resolution' }),
      subTitle: formatMessage({ id: 'Add Board Resolution details for the meeting' }),
      slug: 'Board-Resolution',
    },
    {
      id: 3,
      title: formatMessage({ id: 'Minutes Of Meeting' }),
      subTitle: formatMessage({ id: 'Add meeting summary for quick recall' }),
      slug: 'Minutes-Of-Meeting',
    },
    {
      id: 4,
      title: formatMessage({ id: 'Transcript' }),
      subTitle: formatMessage({ id: 'Add meeting transcript for better accessibility' }),
      slug: 'Transcript',
    },
    {
      id: 5,
      title: formatMessage({ id: 'Other Documents' }),
      subTitle: formatMessage({ id: 'Add important documents related to meeting' }),
      slug: 'Other-Documents',
    },
  ]
  const [files, setFiles] = useState<any[]>([])

  const deleteFile = async () => {
    setCancelLoading(true)
    const isFind = files.find((file) => file.id === id)
    if (isFind) {
      setFiles(files.filter((file) => file.id !== id))
    } else {
      for (const agenda of agendaData) {
        const fileList = agenda.AgendaDocuments.filter((file: any) => file.file.fileId !== id)
        const payload = { fileIds: fileList.map((file: any) => file.file.fileId) }
        try {
          const {
            data: { success, error },
          } = await updateAgenda(payload, meeting.meetingId, agenda.agendaId)
          if (success) {
            getAgendaDetails()
            TagManager.dataLayer({
              dataLayer: {
                event: GTMEvent.AgendaUpdatedSuccessful,
                action: 'normal',
                metadata: {
                  company_id: companyId,
                  user_id: currentUser?.userId,
                  email: currentUser?.email,
                  agenda_details: payload, // Updated with actual payload details
                },
              },
            })
          } else {
            TagManager.dataLayer({
              dataLayer: {
                event: GTMEvent.AgendaUpdateFailed,
                action: 'normal',
                metadata: {
                  company_id: companyId,
                  user_id: currentUser?.userId,
                  email: currentUser?.email,
                  agenda_details: payload,
                  error: error[0],
                },
              },
            })
          }
        } catch (e) {
          TagManager.dataLayer({
            dataLayer: {
              event: GTMEvent.AgendaUpdateFailed,
              action: 'normal',
              metadata: {
                company_id: companyId,
                user_id: currentUser?.userId,
                email: currentUser?.email,
                agenda_details: payload,
                error: e,
              },
            },
          })
        }
      }
    }

    setShowCancelModal(false)
    setCancelLoading(false) // Corrected to false
    toast.success(formatMessage({ id: 'File removed successfully' }))

    TagManager.dataLayer({
      dataLayer: {
        event: GTMEvent.FileRemovedSuccessful,
        action: 'normal',
        metadata: {
          company_id: companyId,
          user_id: currentUser?.userId,
          email: currentUser?.email,
          fileId: id,
        },
      },
    })
  }

  const getData = (index: any) => {
    console.log(tab, index)
    const response = summaryData.find((items: any) => {
      return items.meetingInfoType === options[index].slug
    })
    if (response) {
      setIsEdit(true)
      const fileData = response.SummaryDocuments.map((file: any) => {
        return { id: file.fileId, name: file.file.fileName, fileName: file.file.name }
      })
      setFiles(
        index === 0 && fileTab1.length > fileData.length
          ? fileTab1
          : index === 1 && fileTab2.length > fileData.length
            ? fileTab2
            : index === 2 && fileTab3.length > fileData.length
              ? fileTab3
              : index === 3 && fileTab4.length > fileData.length
                ? fileTab4
                : index === 4 && fileTab5.length > fileData.length
                  ? fileTab5
                  : fileData
      )
      setEditData(response)
      setIsChecked1(isChecked1 ? isChecked1 : response.aiMinofMeeting)
      setIsChecked2(isChecked2 ? isChecked2 : response.aiTranscript)
      setIsDisabled(response.aiMinofMeeting || response.aiTranscript)
    }
  }
  const [transcriptData, setTranscriptData] = useState('')
  const handleToggleChange = () => {
    if (tab === 3) {
      setIsActiveModal(true)
      const isTranscriptData = summaryData.find((data: any) => {
        return data.meetingInfoType === 'Transcript'
      })
      if (isTranscriptData)
        setTranscriptData(isTranscriptData.transcriptNotes.replace(/<[^>]+>/g, ''))
    }
    if (tab === 4) handleTranscript()
  }
  const downloadTxtFile = (value: any) => {
    if (files.length > 0) {
      files.map(async (fileData: any) => {
        const {
          data: { success, data },
        } = await downloadDocument(fileData.fileName, companyId!)
        if (success) {
          const link = document.createElement('a')
          link.href = data
          link.download = fileData.name
          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link)
        }
      })
    }

    if (plainText) {
      const content = plainText
      const element = document.createElement('a')
      const file = new Blob([content], { type: 'text/plain' })
      element.href = URL.createObjectURL(file)
      element.download = `${meeting.meetingId}-${options[tab - 1].slug}.txt`
      document.body.appendChild(element) // Required for this to work in FireFox
      element.click()
      document.body.removeChild(element)
      URL.revokeObjectURL(element.href)
    }
  }
  const handleSubmit = async (values: any) => {
    const isResolutionTitleRequired = tab === 2 && values.ResolutionTitle === ''
    const isFileRequired = !isChecked1 && !isChecked2 && files.length === 0
    const isTabSpecificTextMissing =
      tab === 3 && quillText2 === '' ? true : tab === 4 && quillText3 === '' ? true : false
    if (isResolutionTitleRequired || (isFileRequired && isTabSpecificTextMissing)) {
      toast.error('Please fill in the required fields.')
      return
    }
    if (!radio && !isChecked1 && !isChecked2 && files.length === 0 && tab !== 5) {
      toast.error('Please upload a files')
      return
    }

    const payload = {
      meetingInfoType: options[tab - 1].slug,
      resolutionTitle: tab === 2 ? values.ResolutionTitle : '',
      resolutionNote: tab === 2 ? quillText1 : '',
      aiTranscript: isChecked2,
      transcriptNotes: tab === 4 ? quillText3 : '',
      aiMinofMeeting: isChecked1,
      minutesOfMeetingNotes: tab === 3 ? quillText2 : '',
      fileIds: files.map((file: any) => {
        return file.id
      }),
    }
    if (tab === 5 && files.length === 0) {
      return 0
    } else {
      try {
        setLoading(true)
        const {
          data: { success, error },
        } = await createMeetingSummary(payload, meeting.meetingId)
        if (success) {
          setIsEdit(true)
          getSummaryData()
          toast.success(formatMessage({ id: 'Post-meeting information added successfully.' }))
          TagManager.dataLayer({
            dataLayer: {
              event: GTMEvent.MeetingSummaryCreateSuccessful,
              action: 'normal',
              metadata: {
                company_id: companyId,
                user_id: currentUser?.userId,
                email: currentUser?.email,
                meeting_summary_detail: payload,
              },
            },
          })
        } else {
          TagManager.dataLayer({
            dataLayer: {
              event: GTMEvent.MeetingSummaryCreateFailed,
              action: 'normal',
              metadata: {
                company_id: companyId,
                user_id: currentUser?.userId,
                email: currentUser?.email,
                meeting_summary_detail: payload,
                error: error[0],
              },
            },
          })
        }
      } catch (e) {
        TagManager.dataLayer({
          dataLayer: {
            event: GTMEvent.MeetingSummaryCreateFailed,
            action: 'normal',
            metadata: {
              company_id: companyId,
              user_id: currentUser?.userId,
              email: currentUser?.email,
              meeting_summary_detail: payload,
              error: e,
            },
          },
        })
      } finally {
        setLoading(false)
      }
    }
  }
  const getSummaryData = async () => {
    try {
      const {
        data: { success, data },
      } = await getMeetingSummary(meeting.meetingId)
      if (success) {
        setSummaryData(data)
        if (tab === 1) {
          const response = data.find((items: any) => {
            return items.meetingInfoType === options[0].slug
          })
          if (response) {
            setIsEdit(true)
            const fileData = response.SummaryDocuments.map((file: any) => {
              return { id: file.fileId, name: file.file.fileName, fileName: file.file.name }
            })
            setFiles(fileData)
            setEditData(response)
          }
        }
      }
    } catch (err) {
      console.log(err)
    }
  }
  const handleUpdateSubmit = async (values: any) => {
    const payload = {
      meetingInfoType: options[tab - 1].slug,
      resolutionTitle: tab === 2 ? values.ResolutionTitle : '',
      resolutionNote: tab === 2 ? quillText1 : '',
      aiTranscript: isChecked2,
      transcriptNotes: tab === 4 ? quillText3 : '',
      aiMinofMeeting: isChecked1,
      minutesOfMeetingNotes: tab === 3 ? quillText2 : '',
      fileIds: files.map((file: any) => {
        return file.id
      }),
    }
    try {
      setLoading(true)
      const {
        data: { success, error },
      } = await updateMeetingSummary(payload, meeting.meetingId, editData.summaryId)
      if (success) {
        toast.success(formatMessage({ id: 'Meeting documents updated successfully.' }))
        getSummaryData()
        TagManager.dataLayer({
          dataLayer: {
            event: GTMEvent.MeetingSummaryUpdatedSuccessful,
            action: 'normal',
            metadata: {
              company_id: companyId,
              user_id: currentUser?.userId,
              email: currentUser?.email,
              meeting_summary_detail: payload,
              summary_id: editData.summaryId,
            },
          },
        })
      } else {
        TagManager.dataLayer({
          dataLayer: {
            event: GTMEvent.MeetingSummaryUpdateFailed,
            action: 'normal',
            metadata: {
              company_id: companyId,
              user_id: currentUser?.userId,
              email: currentUser?.email,
              meeting_summary_detail: payload,
              summary_id: editData.summaryId,
              error: error[0],
            },
          },
        })
      }
    } catch (e) {
      TagManager.dataLayer({
        dataLayer: {
          event: GTMEvent.MeetingSummaryUpdateFailed,
          action: 'normal',
          metadata: {
            company_id: companyId,
            user_id: currentUser?.userId,
            email: currentUser?.email,
            meeting_summary_detail: payload,
            summary_id: editData.summaryId,
            error: e,
          },
        },
      })
    } finally {
      setLoading(false)
    }
  }
  const handleTranscript = async () => {
    setLoading1(true)
    const isRecordingData = summaryData.find((data: any) => {
      return data.meetingInfoType === 'Recording'
    })
    if (!isRecordingData) {
      setIsChecked1(false)
      return toast.error('Recording summary is not available.')
    }
    if (isRecordingData.SummaryDocuments.length === 0) {
      setIsChecked2(false)
      return toast.error('No recording document was found.')
    }
    const payload = {
      meetingSummaryId: isRecordingData.summaryId,
      documentId: isRecordingData.SummaryDocuments[0].documentId,
    }
    try {
      const {
        data: { success, data, error },
      } = await aiGenerateTranscript(payload, companyId)
      if (success) {
        setAiGeneratedData(data.transcript)
        TagManager.dataLayer({
          dataLayer: {
            event: GTMEvent.TranscriptSuccessfully,
            action: 'normal',
            metadata: {
              company_id: companyId,
              user_id: currentUser?.userId,
              email: currentUser?.email,
              meetingSummaryId: isRecordingData.summaryId,
              documentId: isRecordingData.SummaryDocuments[0].documentId,
            },
          },
        })
      } else {
        toast.error(error[0])
        TagManager.dataLayer({
          dataLayer: {
            event: GTMEvent.TranscriptFailed,
            action: 'normal',
            metadata: {
              company_id: companyId,
              user_id: currentUser?.userId,
              email: currentUser?.email,
              meetingSummaryId: isRecordingData.summaryId,
              documentId: isRecordingData.SummaryDocuments[0].documentId,
            },
          },
        })
      }
    } catch (e) {
      TagManager.dataLayer({
        dataLayer: {
          event: GTMEvent.TranscriptFailed,
          action: 'normal',
          metadata: {
            company_id: companyId,
            user_id: currentUser?.userId,
            email: currentUser?.email,
            meetingSummaryId: isRecordingData.summaryId,
            documentId: isRecordingData.SummaryDocuments[0].documentId,
          },
        },
      })
    } finally {
      setLoading1(false)
    }
  }

  console.log(loading1)

  useEffect(() => {
    getSummaryData()
    handleTabChange(0)
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (aiGeneratedData) {
      if (tab === 2) {
        setRbNotes(aiGeneratedData)
      }
      if (tab === 3) setMomNotes(aiGeneratedData)
      if (tab === 4) setTransNotes(aiGeneratedData)
    }
  }, [aiGeneratedData]) // eslint-disable-line react-hooks/exhaustive-deps
  const getAgendaDetails = async () => {
    try {
      const {
        data: { success, data },
      } = await getAgenda(meeting.meetingId, true)
      if (success) {
        setAgendaData(data.data)
      }
    } catch (err) {
      console.log('Error fetching agenda:', err)
    }
  }

  const timeZone = localStorage.getItem('timeZone')
  return (
    <>
      <Modal
        show={isActive}
        onHide={() => {
          setIsActive(false)
        }}
        fullscreen
      >
        <Modal.Header closeButton>
          <div className='d-flex flex-column'>
            <p className='m-0'>
              {toTitleCase(meeting?.meetingTitle)} {getDateValue(meeting?.meetingDate.toString())}{' '}
              {` |  ${getTimeZoneValue(meeting?.startTime.toString())}`} {`(${timeZone})`}
            </p>
            <h2>{formatMessage({ id: 'Add Post-Meeting Information' })}</h2>
          </div>
        </Modal.Header>
        <Formik
          initialValues={initialValues}
          validationSchema={userSchema}
          onSubmit={handleSubmit}
          validateOnMount
          enableReinitialize={true}
        >
          {(formik: any) => {
            console.log(formik)
            return (
              <>
                <Modal.Body className='container'>
                  <div
                    className='p-0'
                    style={{
                      overflowX: 'scroll',
                      whiteSpace: 'nowrap',
                      scrollbarWidth: 'none',
                      msOverflowStyle: 'none',
                    }}
                  >
                    <div
                      className='d-flex gap-3 col-md-8 col-12 mt-8 mt-md-0'
                      style={{
                        display: 'flex',
                        flexWrap: 'nowrap',
                        scrollbarWidth: 'none',
                        msOverflowStyle: 'none',
                      }}
                    >
                      {/* Rectangular tabs Start */}
                      {options.map((opt, index) => (
                        <div
                          key={index}
                          className={
                            `col options-container p-4 align-content-center cursor-pointer ` +
                            (tab === index + 1 ? ' selected-option' : '')
                          }
                          style={{ width: '200px', flex: '0 0 auto' }}
                          onClick={() => handleTabChange(index)}
                        >
                          <h1 className='m-0'>{formatMessage({ id: opt.title })}</h1>
                          <p className='mt-2' style={{ whiteSpace: 'normal', color: '#656571' }}>
                            {formatMessage({ id: opt.subTitle })}
                          </p>
                        </div>
                      ))}
                    </div>
                  </div>
                  <div className='d-md-flex justify-content-between w-100 align-items-center mb-6'>
                    {tab === 1 && (
                      <>
                        <div className='my-5'>
                          {isShowHelpBanners && (
                            <InfoCard2
                              title={formatMessage({
                                id: 'How to Add Post-Meeting Details for Compliance Meetings?',
                              })}
                              desc={formatMessage({
                                id: 'Add post-meeting details, including Board Resolution details, documents, minutes of meetings, recordings, and transcripts. This feature is essential for maintaining thorough and accurate compliance records.',
                              })}
                              slug={brandingConfig.helpLinks.complianceMeetingPostMeetingDetails}
                            />
                          )}
                          <div className='d-flex form-label  text-dark font-size-13 mt-4'>
                            {formatMessage({ id: 'Upload Recording' })}
                            <ToolTipUIForModal
                              tooltipText={formatMessage({
                                id: 'Upload any meeting session recordings in MP4, AVI, MP3, WAV, M4A or other audio formats, if available.',
                              })}
                            />
                          </div>
                          <div className='w-100'>
                            <button
                              className='btn btn-primary border border-1 mb-4 px-6 py-4 text-center w-md-auto w-100'
                              type='button'
                              onClick={() => {
                                if (files.length === 0) handleVideoOpen()
                              }}
                              disabled={files.length === 1}
                            >
                              {formatMessage({ id: 'Add Files' })}
                            </button>
                            <p>
                              {formatMessage({
                                id: 'File supported: mp3, mp4, avi, m4a or other audio formats.',
                              })}
                            </p>
                          </div>
                          <div className='mb-4'>
                            {files.length > 0 && (
                              <div className='d-flex form-label  text-dark font-size-13 mt-8'>
                                {formatMessage({ id: 'Uploading Recording Files' })}
                                <ToolTipUIForModal
                                  tooltipText={formatMessage({
                                    id: 'Manage all uploaded documents here.',
                                  })}
                                />
                              </div>
                            )}
                            <div className='w-100'>
                              <ul className='p-0 m-0'>
                                {files.map((file) => (
                                  <li
                                    key={file.id}
                                    className='d-flex align-items-center justify-content-between gap-2 text-decoration-none mb-2'
                                  >
                                    <div className='d-flex'>
                                      <img src={getFileType(file.name)} alt='' />
                                      <p className='p-0 ms-2'>{file.name}</p>
                                    </div>
                                    <button
                                      className='btn btn-secondry p-0 m-0'
                                      onClick={() => {
                                        setShowCancelModal(true)
                                        setId(file.id)
                                      }}
                                      type='button'
                                    >
                                      <img src={deleteIcon} alt='Delete' />
                                    </button>
                                  </li>
                                ))}
                              </ul>
                            </div>
                          </div>
                        </div>
                      </>
                    )}
                    {tab === 2 && (
                      <>
                        <div className='my-5'>
                          {isShowHelpBanners && (
                            <InfoCard2
                              title={formatMessage({
                                id: 'How to Add Post-Meeting Details for Compliance Meetings?',
                              })}
                              desc={formatMessage({
                                id: 'Add post-meeting details, including Board Resolution details, documents, minutes of meetings, recordings, and transcripts. This feature is essential for maintaining thorough and accurate compliance records.',
                              })}
                              slug={brandingConfig.helpLinks.complianceMeetingPostMeetingDetails}
                            />
                          )}

                          <Form>
                            <div className='row'>
                              <TextInput
                                fieldType='text'
                                label={formatMessage({ id: 'Resolution Title' })}
                                fieldName='ResolutionTitle'
                                formik={formik}
                                placeholder={formatMessage({ id: 'Enter Resolution Title' })}
                                toolTipText={formatMessage({
                                  id: 'Provide the Resolution Title that has been passed in this meeting. It can be anything you like.',
                                })}
                                isStarRequired={true}
                                isTooltipForModal={true}
                              />
                              <div className='col-12 d-flex flex-row justify-content-between mb-5'>
                                <div className='col-6'>
                                  <div className='d-flex form-label  text-dark font-size-13 mt-4'>
                                    {formatMessage({ id: 'Board Resolution' })}
                                    <ToolTipUIForModal
                                      tooltipText={formatMessage({
                                        id: 'Add details related to the Board Resolution here. You can either upload it as a file or write with text using AI.',
                                      })}
                                    />
                                  </div>
                                  <div className='w-100 mt-2'>
                                    <input
                                      type='radio'
                                      name='Upload Files'
                                      value='files'
                                      checked={!radio}
                                      onChange={() => {
                                        setRadio(false)
                                      }}
                                    />
                                    <label className='ms-2'>Upload Files</label>
                                    <input
                                      type='radio'
                                      name='Upload Files'
                                      value='text'
                                      className='ms-10'
                                      checked={radio}
                                      onChange={() => {
                                        setRadio(true)
                                      }}
                                    />
                                    <label className='ms-2'>
                                      Write or Generate with Investment Banker AI
                                    </label>
                                  </div>
                                </div>
                              </div>
                              <div className='col-12 d-flex flex-row justify-content-between mb-5'>
                                <div className='col-6'>
                                  <div className='d-flex form-label  text-dark font-size-13 mt-4'>
                                    {formatMessage({ id: 'Upload Document Resolution (If any)' })}
                                    <ToolTipUIForModal
                                      tooltipText={formatMessage({
                                        id: 'Upload documents related to this Board Resolution, such as the signed resolution..',
                                      })}
                                    />
                                  </div>
                                  <div className='w-100'>
                                    <button
                                      className='btn btn-primary border border-1 mb-4 px-6 py-4 text-center w-md-auto w-100'
                                      type='button'
                                      onClick={handleOpen}
                                      disabled={radio}
                                    >
                                      {formatMessage({ id: 'Add Files' })}
                                    </button>
                                  </div>
                                </div>
                                <div className='mb-4 col-6'>
                                  {files.length > 0 && (
                                    <div className='d-flex form-label  text-dark font-size-13 mt-4'>
                                      {formatMessage({ id: 'Uploaded Documents' })}
                                      <ToolTipUIForModal
                                        tooltipText={formatMessage({
                                          id: 'Manage all uploaded documents here.',
                                        })}
                                      />
                                    </div>
                                  )}
                                  <div className='w-100'>
                                    <ul className='p-0 m-0'>
                                      {files.map((file) => (
                                        <li
                                          key={file.id}
                                          className='d-flex align-items-center justify-content-between gap-2 text-decoration-none mb-2'
                                        >
                                          <div className='d-flex'>
                                            <img src={getFileType(file.name)} alt='' />
                                            <p className='p-0 ms-2'>{file.name}</p>
                                          </div>
                                          <button
                                            className='btn btn-secondry p-0 m-0'
                                            onClick={() => {
                                              setShowCancelModal(true)
                                              setId(file.id)
                                            }}
                                            type='button'
                                          >
                                            <img src={deleteIcon} alt='Delete' />
                                          </button>
                                        </li>
                                      ))}
                                    </ul>
                                  </div>
                                </div>
                              </div>
                              <label className='d-flex form-label font-size-13 text-dark text-capitalize ms-3 ms-md-0'>
                                {'Board Resolution Note'}{' '}
                                <ToolTipUIForModal
                                  tooltipText={formatMessage({
                                    id: 'Enter the details or key points included in this Board Resolution.',
                                  })}
                                />
                              </label>
                              <div>
                                <Quill
                                  quillText={quillText1}
                                  setQuillText={setQuillText1}
                                  aiEmailResponse={rbNotes || formik.values.BoardResolutionNote}
                                  formik={formik}
                                  setPlainText={setPlainText}
                                  isDisabled={!radio}
                                />
                              </div>
                              <div className='mt-5'>
                                <button
                                  className='btn btn-primary fw-normal w-100 w-md-auto me-4'
                                  type='button'
                                  onClick={() => {
                                    setIsActiveModal(true)
                                  }}
                                  disabled={!radio}
                                >
                                  {formatMessage({ id: 'Generate BR with AI' })}
                                </button>
                                <button
                                  className='btn btn-primary fw-normal w-100 w-md-auto'
                                  type='button'
                                  disabled={!isEdit}
                                  onClick={() =>
                                    downloadTxtFile(rbNotes || formik.values.BoardResolutionNote)
                                  }
                                >
                                  {formatMessage({ id: 'Download' })}
                                </button>
                              </div>
                            </div>
                          </Form>
                        </div>
                      </>
                    )}
                    {tab === 3 && (
                      <>
                        <div className='my-5'>
                          {isShowHelpBanners && (
                            <InfoCard2
                              title={formatMessage({
                                id: 'How to Add Post-Meeting Details for Compliance Meetings?',
                              })}
                              desc={formatMessage({
                                id: 'Add post-meeting details, including Board Resolution details, documents, minutes of meetings, recordings, and transcripts. This feature is essential for maintaining thorough and accurate compliance records.',
                              })}
                              slug={brandingConfig.helpLinks.complianceMeetingPostMeetingDetails}
                            />
                          )}
                          <div className='mb-3'>
                            <form className='form-check form-check-custom form-check-solid form-check-primary form-switch pb-3 pt-3'>
                              <div className='col-12 d-flex flex-row justify-content-between mb-5'>
                                <div className='col-6'>
                                  <div className='d-flex form-label  text-dark font-size-13 mt-4'>
                                    {formatMessage({ id: 'Minutes of Meeting' })}
                                    <ToolTipUIForModal
                                      tooltipText={formatMessage({
                                        id: 'Add details related to the Minutes of Meeting here. You can either upload it as a file or write with text using AI.',
                                      })}
                                    />
                                  </div>
                                  <div className='w-100 mt-2'>
                                    <input
                                      type='radio'
                                      name='Upload Files'
                                      value='files'
                                      checked={!isChecked1}
                                      onChange={() => {
                                        setIsChecked1(false)
                                      }}
                                    />
                                    <label className='ms-2'>Upload Files</label>
                                    <input
                                      type='radio'
                                      name='Upload Files'
                                      value='text'
                                      className='ms-10'
                                      checked={isChecked1}
                                      onChange={() => {
                                        setIsChecked1(true)
                                      }}
                                    />
                                    <label className='ms-2'>
                                      Write or Generate with Investment Banker AI
                                    </label>
                                  </div>
                                </div>
                              </div>
                            </form>
                          </div>

                          <Form>
                            <div className='row'>
                              <div className='col-12 d-flex flex-row justify-content-between mb-5'>
                                <div className='col-6'>
                                  <div className='d-flex form-label  text-dark font-size-13 mt-4'>
                                    {formatMessage({ id: 'Upload Documents (If any)' })}
                                    <ToolTipUIForModal
                                      tooltipText={formatMessage({
                                        id: 'Upload documents related to the Minutes of Meeting (MoM), such as the signed MoM in PDF format.',
                                      })}
                                    />
                                  </div>
                                  <div className='w-100'>
                                    <button
                                      className='btn btn-primary border border-1 mb-4 px-6 py-4 text-center w-md-auto w-100'
                                      type='button'
                                      onClick={handleOpen}
                                      disabled={isChecked1}
                                    >
                                      {formatMessage({ id: 'Add Files' })}
                                    </button>
                                  </div>
                                </div>
                                <div className='mb-4 col-6'>
                                  {files.length > 0 && (
                                    <div className='d-flex form-label  text-dark font-size-13 mt-4'>
                                      {formatMessage({ id: 'Uploaded Documents' })}
                                      <ToolTipUIForModal
                                        tooltipText={formatMessage({
                                          id: 'Manage all uploaded documents here.',
                                        })}
                                      />
                                    </div>
                                  )}
                                  <div className='w-100'>
                                    <ul className='p-0 m-0'>
                                      {files.map((file) => (
                                        <li
                                          key={file.id}
                                          className='d-flex align-items-center justify-content-between gap-2 text-decoration-none mb-2'
                                        >
                                          <div className='d-flex'>
                                            <img src={getFileType(file.name)} alt='' />
                                            <p className='p-0 ms-2'>{file.name}</p>
                                          </div>
                                          <button
                                            className='btn btn-secondry p-0 m-0'
                                            onClick={() => {
                                              setShowCancelModal(true)
                                              setId(file.id)
                                            }}
                                            type='button'
                                          >
                                            <img src={deleteIcon} alt='Delete' />
                                          </button>
                                        </li>
                                      ))}
                                    </ul>
                                  </div>
                                </div>
                              </div>
                              <label className='d-flex form-label font-size-13 text-dark text-capitalize ms-3 ms-md-0'>
                                {'Minutes-of-Meeting'}{' '}
                                <ToolTipUIForModal
                                  tooltipText={formatMessage({
                                    id: 'Add minutes-of-meeting (MoM) in text form here for quick recall & search for attendees.',
                                  })}
                                />
                              </label>
                              <div>
                                <Quill
                                  quillText={quillText2}
                                  setQuillText={setQuillText2}
                                  aiEmailResponse={momNotes || formik.values.MinutesofMeeting}
                                  formik={formik}
                                  setPlainText={setPlainText}
                                  isDisabled={!isChecked1}
                                />
                              </div>
                              <div className='mt-5'>
                                <button
                                  className='btn btn-primary fw-normal w-100 w-md-auto me-4'
                                  type='button'
                                  onClick={handleToggleChange}
                                  disabled={!isChecked1}
                                >
                                  {formatMessage({ id: 'Generate MoM with AI' })}
                                </button>
                                <button
                                  className='btn btn-primary fw-normal w-100 w-md-auto'
                                  type='button'
                                  disabled={!isEdit}
                                  onClick={() =>
                                    downloadTxtFile(momNotes || formik.values.MinutesofMeeting)
                                  }
                                >
                                  {formatMessage({ id: 'Download' })}
                                </button>
                              </div>
                            </div>
                          </Form>
                        </div>
                      </>
                    )}
                    {tab === 4 && (
                      <>
                        <div className='my-5'>
                          {isShowHelpBanners && (
                            <InfoCard2
                              title={formatMessage({
                                id: 'How to Add Post-Meeting Details for Compliance Meetings?',
                              })}
                              desc={formatMessage({
                                id: 'Add post-meeting details, including Board Resolution details, documents, minutes of meetings, recordings, and transcripts. This feature is essential for maintaining thorough and accurate compliance records.',
                              })}
                              slug={brandingConfig.helpLinks.complianceMeetingPostMeetingDetails}
                            />
                          )}
                          <div className='mb-3'>
                            <form className='form-check form-check-custom form-check-solid form-check-primary form-switch pb-3 pt-3'>
                              <div className='col-12 d-flex flex-row justify-content-between mb-5'>
                                <div className='col-6'>
                                  <div className='d-flex form-label  text-dark font-size-13 mt-4'>
                                    {formatMessage({ id: 'Transcript' })}
                                    <ToolTipUIForModal
                                      tooltipText={formatMessage({
                                        id: 'Add details related to the Transcript here. You can either upload it as a file or write with text using AI.',
                                      })}
                                    />
                                  </div>
                                  <div className='w-100 mt-2'>
                                    <input
                                      type='radio'
                                      name='Upload Files'
                                      value='files'
                                      checked={!isChecked2}
                                      onChange={() => {
                                        setIsChecked2(false)
                                      }}
                                    />
                                    <label className='ms-2'>Upload Files</label>
                                    <input
                                      type='radio'
                                      name='Upload Files'
                                      value='text'
                                      className='ms-10'
                                      checked={isChecked2}
                                      onChange={() => {
                                        setIsChecked2(true)
                                      }}
                                    />
                                    <label className='ms-2'>
                                      Write or Generate with Investment Banker AI
                                    </label>
                                  </div>
                                </div>
                              </div>
                            </form>
                          </div>
                          <Form>
                            <div className='row'>
                              <div className='col-12 d-flex flex-row justify-content-between mb-5'>
                                <div className='col-6'>
                                  <div className='d-flex form-label  text-dark font-size-13 mt-4'>
                                    {formatMessage({ id: 'Upload Document (If any)' })}
                                    <ToolTipUIForModal
                                      tooltipText={formatMessage({
                                        id: 'Upload only one transcript file of the meeting, if any.',
                                      })}
                                    />
                                  </div>
                                  <div className='w-100'>
                                    <button
                                      className='btn btn-primary border border-1 mb-4 px-6 py-4 text-center w-md-auto w-100'
                                      type='button'
                                      onClick={() => {
                                        if (files.length === 0) handleVideoOpen1()
                                      }}
                                      disabled={files.length === 1 || isChecked2}
                                    >
                                      {formatMessage({ id: 'Add File' })}
                                    </button>
                                  </div>
                                </div>
                                <div className='mb-4 col-6'>
                                  {files.length > 0 && (
                                    <div className='d-flex form-label  text-dark font-size-13 mt-4'>
                                      {formatMessage({ id: 'Uploaded Documents' })}
                                      <ToolTipUIForModal
                                        tooltipText={formatMessage({
                                          id: 'Manage all uploaded documents here.',
                                        })}
                                      />
                                    </div>
                                  )}
                                  <div className='w-100'>
                                    <ul className='p-0 m-0'>
                                      {files.map((file) => (
                                        <li
                                          key={file.id}
                                          className='d-flex align-items-center justify-content-between gap-2 text-decoration-none mb-2'
                                        >
                                          <div className='d-flex'>
                                            <img src={getFileType(file.name)} alt='' />
                                            <p className='p-0 ms-2'>{file.name}</p>
                                          </div>
                                          <button
                                            className='btn btn-secondry p-0 m-0'
                                            onClick={() => {
                                              setShowCancelModal(true)
                                              setId(file.id)
                                            }}
                                            type='button'
                                          >
                                            <img src={deleteIcon} alt='Delete' />
                                          </button>
                                        </li>
                                      ))}
                                    </ul>
                                  </div>
                                </div>
                              </div>
                              <label className='d-flex form-label font-size-13 text-dark text-capitalize ms-3 ms-md-0'>
                                {formatMessage({ id: 'Meeting Transcript' })}{' '}
                                <ToolTipUIForModal
                                  tooltipText={formatMessage({
                                    id: 'Add transcript of the meeting for attendees.',
                                  })}
                                />
                              </label>
                              <div>
                                <Quill
                                  quillText={quillText3}
                                  setQuillText={setQuillText3}
                                  aiEmailResponse={transNotes || formik.values.MeetingTranscript}
                                  formik={formik}
                                  setPlainText={setPlainText}
                                  isDisabled={!isChecked2}
                                />
                              </div>
                              <div className='mt-5'>
                                <button
                                  className='btn btn-primary fw-normal w-100 w-md-auto me-4'
                                  type='button'
                                  onClick={handleToggleChange}
                                  disabled={!isChecked2 || loading1}
                                >
                                  {loading1
                                    ? formatMessage({ id: 'Please wait ...' })
                                    : formatMessage({ id: 'Generate Transcript with AI' })}
                                </button>
                                <button
                                  className='btn btn-primary fw-normal w-100 w-md-auto'
                                  type='button'
                                  disabled={!isEdit}
                                  onClick={() =>
                                    downloadTxtFile(transNotes || formik.values.MeetingTranscript)
                                  }
                                >
                                  {formatMessage({ id: 'Download' })}
                                </button>
                              </div>
                            </div>
                          </Form>
                        </div>
                      </>
                    )}
                    {tab === 5 && (
                      <>
                        <div className='my-5'>
                          {isShowHelpBanners && (
                            <InfoCard2
                              title={formatMessage({
                                id: 'How to Add Post-Meeting Details for Compliance Meetings?',
                              })}
                              desc={formatMessage({
                                id: 'Add post-meeting details, including Board Resolution details, documents, minutes of meetings, recordings, and transcripts. This feature is essential for maintaining thorough and accurate compliance records.',
                              })}
                              slug={brandingConfig.helpLinks.complianceMeetingPostMeetingDetails}
                            />
                          )}
                          <div className='d-flex form-label  text-dark font-size-13 mt-4'>
                            {formatMessage({ id: 'Upload Document (If any)' })}
                            <ToolTipUIForModal
                              tooltipText={formatMessage({
                                id: 'Upload any other documents related to this meeting here.',
                              })}
                            />
                          </div>
                          <div className='w-100'>
                            <button
                              className='btn btn-primary border border-1 mb-4 px-6 py-4 text-center w-md-auto w-100'
                              type='button'
                              onClick={handleOpen}
                            >
                              {formatMessage({ id: 'Add Files' })}
                            </button>
                          </div>
                          <div className='mb-4'>
                            {files.length > 0 && (
                              <div className='d-flex form-label  text-dark font-size-13 mt-8'>
                                {formatMessage({ id: 'Uploaded Documents' })}
                                <ToolTipUIForModal
                                  tooltipText={formatMessage({
                                    id: 'Manage all uploaded documents here.',
                                  })}
                                />
                              </div>
                            )}
                            <div className='w-100'>
                              <ul className='p-0 m-0'>
                                {files.map((file) => (
                                  <li
                                    key={file.id}
                                    className='d-flex align-items-center justify-content-between gap-2 text-decoration-none mb-2'
                                  >
                                    <div className='d-flex'>
                                      <img src={getFileType(file.name)} alt='' />
                                      <p className='p-0 ms-2'>{file.name}</p>
                                    </div>
                                    <button
                                      className='btn btn-secondry p-0 m-0'
                                      onClick={() => {
                                        setShowCancelModal(true)
                                        setId(file.id)
                                      }}
                                      type='button'
                                    >
                                      <img src={deleteIcon} alt='Delete' />
                                    </button>
                                  </li>
                                ))}
                                {agendaData?.map((data: any, index: number) =>
                                  data.AgendaDocuments?.map((file: any, subIndex: number) => (
                                    <li
                                      key={file.file.fileId}
                                      className='d-flex align-items-center justify-content-between gap-2 text-decoration-none mb-2'
                                    >
                                      <div className='d-flex'>
                                        <img src={getFileType(file.file.name)} alt='' />
                                        <p className='p-0 ms-2'>{file.file.fileName}</p>
                                      </div>
                                      <button
                                        className='btn btn-secondry p-0 m-0'
                                        onClick={() => {
                                          setShowCancelModal(true)
                                          setId(file.file.fileId)
                                        }}
                                        type='button'
                                      >
                                        <img src={deleteIcon} alt='Delete' />
                                      </button>
                                    </li>
                                  ))
                                )}
                              </ul>
                            </div>
                          </div>
                        </div>
                      </>
                    )}
                  </div>

                  <FileUpload
                    fileSize={parseInt(process.env.REACT_APP_STAKEHOLDERS_MAX_FILE_SIZE as string)}
                    maxFileNumber={1}
                    allowType={['video/*', 'audio/*']}
                    metaData={{ module: 'document', isProtected: false }}
                    modalStatus={modelVideoStatus}
                    handleClose={handleVideoClose}
                    handleSuccess={(id: number, name: string) => {
                      setFiles((prevFiles: any) => [
                        ...prevFiles,
                        { id, name: name.split('/').pop() },
                      ])
                      const currentFileIds = Array.isArray(formik.values.fileIds)
                        ? formik.values.fileIds
                        : []
                      formik.setFieldValue('fileIds', [...currentFileIds, id])
                    }}
                    resourceType='all'
                  />
                  <FileUpload
                    fileSize={parseInt(process.env.REACT_APP_STAKEHOLDERS_MAX_FILE_SIZE as string)}
                    maxFileNumber={1}
                    allowType={allowedFileTypes}
                    metaData={{ module: 'document', isProtected: false }}
                    modalStatus={modelVideoStatus1}
                    handleClose={handleVideoClose1}
                    handleSuccess={(id: number, name: string) => {
                      setFiles((prevFiles: any) => [
                        ...prevFiles,
                        { id, name: name.split('/').pop() },
                      ])
                      const currentFileIds = Array.isArray(formik.values.fileIds)
                        ? formik.values.fileIds
                        : []
                      formik.setFieldValue('fileIds', [...currentFileIds, id])
                    }}
                    resourceType='all'
                  />
                  <FileUpload
                    fileSize={parseInt(process.env.REACT_APP_STAKEHOLDERS_MAX_FILE_SIZE as string)}
                    maxFileNumber={10}
                    allowType={allowedFileTypes}
                    metaData={{ module: 'document', isProtected: false }}
                    modalStatus={modelStatus}
                    handleClose={handleClose}
                    handleSuccess={(id: number, name: string) => {
                      setFiles((prevFiles: any) => [
                        ...prevFiles,
                        { id, name: name.split('/').pop() },
                      ])
                      const currentFileIds = Array.isArray(formik.values.fileIds)
                        ? formik.values.fileIds
                        : []
                      formik.setFieldValue('fileIds', [...currentFileIds, id])
                    }}
                    resourceType='all'
                  />
                </Modal.Body>
                <Modal.Footer className='p-md-0 px-0 container d-flex'>
                  <div className='d-flex my-md-4 mx-6 mx-md-0 my-0 mb-2 justify-content-md-end justify-content-center w-md-auto w-100 order-2 order-md-1 mb-2'>
                    <button
                      className='btn bg-light custom-button-property text-muted font-size-13 me-md-2 me-0 fw-normal w-100 w-md-auto'
                      style={{ padding: '15px 40px' }}
                      type='button'
                      onClick={() => setIsActive(false)}
                    >
                      <span className='indicator-label font-size-13 p-0'>
                        {formatMessage({ id: 'Cancel' })}
                      </span>
                    </button>
                  </div>
                  <div className='d-flex my-md-4 mx-6 mx-md-0 my-0 justify-content-md-end justify-content-center w-md-auto w-100 order-1 order-md-2 mb-2'>
                    <button
                      className='btn bg-primary custom-button-property text-white font-size-13 me-md-2 me-0 fw-normal w-100 w-md-auto'
                      style={{ padding: '15px 40px' }}
                      type='button'
                      disabled={loading}
                      onClick={() => {
                        isEdit ? handleUpdateSubmit(formik.values) : handleSubmit(formik.values)
                      }}
                    >
                      <span className='indicator-label font-size-13 p-0'>
                        {loading
                          ? formatMessage({ id: 'Please wait ...' })
                          : formatMessage({ id: 'Save' })}
                      </span>
                    </button>
                  </div>
                </Modal.Footer>
              </>
            )
          }}
        </Formik>
      </Modal>
      {isActiveModal && (
        <AIGeneratedBrModal
          isActiveModal={isActiveModal}
          setIsActiveModal={setIsActiveModal}
          isTab={tab}
          setAiGeneratedData={setAiGeneratedData}
          transcriptData={transcriptData}
        />
      )}
      <DeleteFileConfirmationModal
        setDeleteShowModal={setShowCancelModal}
        showDeleteModal={showCancelModal}
        onDeleteSubmit={deleteFile}
        deleteLoading={cancelLoading}
      />
    </>
  )
}
